// extracted by mini-css-extract-plugin
export var actionText = "_s5-4";
export var container = "_s5-0";
export var leftSection = "_s5-1";
export var rightSection = "_s5-2";
export var settingsButton = "_s5-6";
export var settingsIcon = "_s5-7";
export var shortcut = "_s5-5";
export var shortcutGroup = "_s5-3";